import { clsx } from '@mantine/styles'
import { useState } from 'react'
import { Link } from 'react-router-dom'

import { ActionsMenu } from '../ActionsMenu/ActionsMenu'
import { BottomTabBar } from '../BottomTabBar'
import { MobileMenuDrawer } from '../MobileMenuDrawer'
import { SpotlightSearch } from '../SpotlightSearch/SpotlightSearch'
import { NavLinkConfig, NavMenuSection } from '../useNavigationItems'

import { useHideOnScroll } from '@percent/workplace-giving/common/hooks'
import { AppRoute } from '@percent/workplace-giving/routing/AppRoute.enum'
import classes from './MobileNavBar.module.scss'

/** The bottom bar shows at most three destinations before the "More" tab. */
const MAX_TABS = 3

type MobileNavBarProps = {
  navLinks: NavLinkConfig[]
  menuSections: NavMenuSection[]
  accountName: string
  partnerLogo?: string | null
  partnerName: string
}

export function MobileNavBar({
  navLinks,
  menuSections,
  accountName,
  partnerLogo,
  partnerName
}: Readonly<MobileNavBarProps>) {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  // Keep the header while the drawer is open, so its close button stays put.
  const isHeaderHidden = useHideOnScroll() && !isMenuOpen

  const tabs = navLinks.slice(0, MAX_TABS)
  const overflowLinks = navLinks.slice(MAX_TABS)

  return (
    <>
      <header className={clsx(classes.header, { [classes.headerHidden]: isHeaderHidden })}>
        {partnerLogo ? (
          <Link className={classes.logoWrapper} to={AppRoute.HOME}>
            <img alt={`${partnerName} logo`} src={partnerLogo} />
          </Link>
        ) : (
          <span />
        )}

        <div className={classes.actions}>
          <ActionsMenu />
          <SpotlightSearch />
        </div>
      </header>

      <BottomTabBar isMenuOpen={isMenuOpen} tabs={tabs} onMenuToggle={() => setIsMenuOpen(open => !open)} />

      <MobileMenuDrawer
        accountName={accountName}
        menuSections={menuSections}
        opened={isMenuOpen}
        overflowLinks={overflowLinks}
        partnerLogo={partnerLogo}
        partnerName={partnerName}
        onClose={() => setIsMenuOpen(false)}
      />
    </>
  )
}
